import * as actionTypes from 'constants/ActionTypes';

const cargoGazetters = (state = {
    items: [],
    errors: [],
    isLoaded: false,
    search: '',
}, action) => {
    switch (action.type) {
    case actionTypes.GET_CARGO_GAZETTERS.REQUEST:
        return {
            ...state,
            items: [],
            errors: [],
            isLoaded: false,
        };
    case actionTypes.GET_CARGO_GAZETTERS.SUCCESS: {
        const items = action.data.items.map(item => ({
            ...item,
            prevState: item,
            isUpdate: false,
        }));

        return {
            ...state,
            ...action.data,
            items,
            errors: [],
            isLoaded: true,

        };
    }
    case actionTypes.GET_CARGO_GAZETTERS.FAILURE:
        return {
            ...state,
            errors: action.errors,
            isLoaded: true,
        };

    case actionTypes.DELETE_CARGO_GAZETTER.REQUEST:
        return {
            ...state,
        };
    case actionTypes.DELETE_CARGO_GAZETTER.SUCCESS: {
        const items = state.items.filter(item => !(item._id === action.item._id));

        return {
            ...state,
            items,
        };
    }
    case actionTypes.DELETE_CARGO_GAZETTER.FAILURE:
        return {
            ...state,
        };   
    default:
        return state;
    }
};

export default cargoGazetters;



// WEBPACK FOOTER //
// ./app/reducers/cargoes/gazetters.js